import { Box, Switch, styled } from "@mui/material";
import { useDispatch } from "react-redux";
import { homeAction } from "redux/slice/home";

const prefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";
const VolumeOffIcon = `${prefix}/images/icons/volume_off.svg`;
const VolumeOnIcon = `${prefix}/images/icons/volume_on.svg`;

const VolumeSwitch = styled(Switch)(() => ({
  // width: 62,
  // height: 24,
  padding: 5,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(0px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(20px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url(${VolumeOnIcon})`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    width: 18,
    height: 18,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "11px",
      height: "11px",
      left: 3.5,
      top: 3.5,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url(${VolumeOffIcon})`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#aab4be",
    borderRadius: 20 / 2,
    height: "10px",
  },
}));

const SoundToggle = ({ user, soundEnabled }) => {
  const dispatch = useDispatch();
  const handleToggle = async (event) => {
    const newValue = event.target.checked;
    dispatch(
      homeAction.updateSoundEnabled({ uclId: user.userCompanyLinkId, soundEnabled: newValue })
    );
  };

  return (
    <Box style={{ display: "flex", alignItems: "center", position: "absolute", top: 40 }}>
      <VolumeSwitch
        checked={soundEnabled}
        onChange={handleToggle}
        name="volumeToggle"
        color="primary"
      />
    </Box>
  );
};

export default SoundToggle;
